/* eslint-disable @typescript-eslint/no-explicit-any */
import { Field, Input } from '@fluentui/react-components';
import { useCallback, useMemo } from 'react';
import { TextAreaHelperText, TextAreaWithHighLights } from 'src/pages/automation-rule/work-item-variables';
import { useAutomationRuleActions } from '../use-actions';
import { ActionItemType, SendEmailNotificationActionType, SendEmailNotificationErrorType } from '../types';
import { useStyles } from './styles';
import UserFieldInput from './user-field';

interface Props {
  actionId: string;
	validations: SendEmailNotificationErrorType | null;
}

export default function SendEmailNotification(props: Props) {
	const classes = useStyles();
	const {actions, setActions, resetValidationErrors} = useAutomationRuleActions();

	const current = useMemo(() => {
		const current = actions.find(item => item.id == props.actionId) as ActionItemType;
		return current.sendEmailNotification as SendEmailNotificationActionType;
	}, [actions, props.actionId]);

	const changeSubjectValue = useCallback((value: string) => {
		resetValidationErrors();
		setActions(oldActions => {
			const others = oldActions.filter(item => item.id !== props.actionId);
			const found = oldActions.find(item => item.id === props.actionId) as ActionItemType;
			return [
				...others,
				{
					...found,
					sendEmailNotification: {
						...found.sendEmailNotification as SendEmailNotificationActionType,
						subject: value
					}
				}
			];
		});
	}, [props.actionId]);

	const changeTextValue = useCallback((value: string) => {
		resetValidationErrors();
		setActions(oldActions => {
			const others = oldActions.filter(item => item.id !== props.actionId);
			const found = oldActions.find(item => item.id === props.actionId) as ActionItemType;
			return [
				...others,
				{
					...found,
					sendEmailNotification: {
						...found.sendEmailNotification as SendEmailNotificationActionType,
						text: value
					}
				}
			];
		});
	}, [props.actionId]);

	return (
		<div className={classes.root}>
			<UserFieldInput
				actionId={props.actionId}
				validationError={props.validations?.to || null}
				isMultiSelect={true}
			/>
			<Field
				className={classes.fieldRoot}
				validationMessage={props.validations?.subject}
			>
				<Input
					placeholder='Subject'
					appearance='outline'
					className={classes.input}
					value={current.subject}
					onChange={(ev) => {
						changeSubjectValue(ev.target.value);
					}}
				/>
			</Field>
			<Field
				className={classes.fieldRoot}
				validationMessage={props.validations?.text}
			>
				<TextAreaWithHighLights
					messageError={props.validations?.text}
					placeholder='Email Message'
					value={current.text}
					onChange={(value) => {
						changeTextValue(value);
					}}
				/>
			</Field>
			<TextAreaHelperText />
		</div>
	);
}
